import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganizationIndexTreeMapper from "../service/OrganizationIndexTreeMapper";

export default class GetOrganisationIndexTreeInteractor {
  private resource: FindResourceEntryInteractor<IOrganisationIndexGroup[]>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(organisationId: number, categoryId: number) {
    return this.resource.execute(
      `organisations/${organisationId}/index-categories`,
      OrganizationIndexTreeMapper,
      () => {},
      categoryId
    );
  }
}
